import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import {
  CustomTabPanel,
  CustomTabPanel2,
  StyledTab,
  StyledTabs,
  a11yProps,
} from "../Common/UI/TabPanel";
import General from "./Tabs/General";
// import StudyProperties from "./Tabs/StudyProperties";
import Sites from "./Tabs/Sites";
// import Randomization from "./Tabs/Randomization";
import { HeaderStyle } from "../Common/styles/header";
import { useAppSelector } from "../../Redux/hooks";
import { permissions } from "../../utils/roles";
// import RandomizationList from "./Tabs/RandomizationList";
import OptionGroup from "./Tabs/OptionGroup";
// import Features from "./Tabs/Features";
// import { featuresMap } from "../../utils/features";
import StudyProperties from "./Tabs/StudyProps";
// import ConfigBody from "../GarminConfig/ConfigBody";
import EmailConfig from "./ThemeSettings/EmailConfig";
import LandingPageBuilder from "./Tabs/LandingPageBuilder";
import Documents from "./Tabs/Documents";
import { useSearchParams, useParams } from "react-router-dom";
import { useQuery } from "../../utils/hooks";
import FlyerCard from "./FlyerCard";
import { scrollableTabPageContent } from "../../utils/dataTableShell";

const StudySettings = () => {
  const { id: studyId } = useParams();
  const status = useAppSelector((state) => state.study.status);
  const languages = useAppSelector((state) => state.study.languages);
  // const { features } = useAppSelector((state) => state.study);
  const studyPermissions = useAppSelector(
    (state) => state.study.studyPermissions
  );
  const dataEditable = useAppSelector((state) => state.study.dataEditable);
  let [, setSearchParams] = useSearchParams();

  const queryType = useQuery().get("type");
  const queryRedirect = useQuery().get("redirect");

  const [type, setType] = useState(queryType ?? "general");

  const handleChange = (_: any, newValue: string) => {
    setType(newValue);
  };

  useEffect(() => {
    if (queryRedirect && queryType) {
      setType(queryType);
    }
  }, [queryRedirect, queryType]);

  const [hasAccess] = useState(
    studyPermissions.includes(permissions.studySettings) && dataEditable
  );

  const [canEdit] = useState(
    status === "not_live" &&
      studyPermissions.includes(permissions.studySettings)
  );

  useEffect(() => {
    const params = new URLSearchParams();

    if (type) {
      params.set("type", type);
    }

    setSearchParams(params, {
      replace: true,
    });
  }, [setSearchParams, type]);

  return (
    <>
      <Box sx={HeaderStyle}>
        <Typography variant="h2" color="text.primary">
          Study Settings
        </Typography>
        {/* {type === "randomization" &&
          hasAccess &&
          features?.[featuresMap.randomization] && (
            <Box sx={{ ml: "auto", display: "flex", gap: 2 }}>
              {features?.[featuresMap.randomizationUploadFile] && (
                <Button
                  variant="outlined"
                  onClick={() => setModalContent("upload")}
                  startIcon={<Add />}
                >
                  Upload File
                </Button>
              )}

              {features?.[featuresMap.algoRandomization] && (
                <Button
                  variant="contained"
                  onClick={() => setModalContent("randomization")}
                  startIcon={<Add />}
                >
                  Create Randomization
                </Button>
              )}
            </Box>
          )} */}
      </Box>
      <Box sx={{ borderBottom: 1, borderColor: "#E5E7EB" }}>
        <StyledTabs value={type} onChange={handleChange}>
          <StyledTab label="General" value="general" {...a11yProps(0)} />
          <StyledTab label="Flyer" value="flyer" {...a11yProps(1)} />
          <StyledTab
            label="Study Properties"
            value="study_properties"
            {...a11yProps(2)}
          />
          {/* <StyledTab
              label="Study Properties"
              value="study_properties"
              {...a11yProps(1)}
            /> */}
          <StyledTab label="Sites" value="sites" {...a11yProps(3)} />

          {/* {features?.[featuresMap.randomization] && (
              <StyledTab
                label="Randomization"
                value="randomization"
                {...a11yProps(3)}
              />
            )} */}
          <StyledTab
            label="Choice Values"
            value="option_group"
            {...a11yProps(4)}
          />
          {/* <StyledTab
              label="Menu Labels"
              value="menu_labels"
              {...a11yProps(5)}
            /> */}
          {/* <StyledTab label="Features" value="features" {...a11yProps(3)} /> */}
          {/* {features?.[featuresMap.wearable] && (
              <StyledTab
                label="Device Configuration"
                value="device_config"
                {...a11yProps(7)}
              />
            )} */}
          <StyledTab
            label="Email Config"
            value="email_config"
            {...a11yProps(5)}
          />
          <StyledTab
            label="Landing Page Builder"
            value="landing_page_builder"
            {...a11yProps(6)}
          />
          <StyledTab label="Documents" value="documents" {...a11yProps(7)} />
        </StyledTabs>
      </Box>
      <Box sx={scrollableTabPageContent("calc(100vh - 185px)", 3)}>
        <CustomTabPanel value={type} index={"general"}>
          <General canEdit={hasAccess} />
        </CustomTabPanel>
        <CustomTabPanel value={type} index={"flyer"}>
          <FlyerCard studyId={studyId} />
        </CustomTabPanel>
        <CustomTabPanel value={type} index={"study_properties"}>
          <StudyProperties canEdit={canEdit} />
        </CustomTabPanel>
        {/* <CustomTabPanel value={type} index={"study_properties"}>
            <StudyProperties canEdit={canEdit} />
          </CustomTabPanel> */}
        <CustomTabPanel2 value={type} index={"sites"}>
          <Sites canEdit={hasAccess} />
        </CustomTabPanel2>
        {/* <CustomTabPanel value={type} index={"randomization"}>
            <Randomization canEdit={canEditSettings} />
          </CustomTabPanel> */}
        {/* {features?.[featuresMap.randomization] && (
            <CustomTabPanel value={type} index={"randomization"}>
              <RandomizationList
                modalContent={modalContent}
                setModalContent={setModalContent}
                canEdit={hasAccess}
              />
            </CustomTabPanel>
          )} */}

        <CustomTabPanel2 value={type} index={"option_group"}>
          <OptionGroup canEdit={canEdit} />
        </CustomTabPanel2>
        {/* <CustomTabPanel value={type} index={"menu_labels"}>
            <MenuLabels
              modalContent={modalContent}
              setModalContent={setModalContent}
              canEdit={canEdit}
            />
          </CustomTabPanel> */}
        {/* <CustomTabPanel value={type} index={"features"}>
          <Features canEdit={canEdit} />
        </CustomTabPanel> */}
        <CustomTabPanel value={type} index={"email_config"}>
          <EmailConfig canEdit={hasAccess} studyId={studyId} />
        </CustomTabPanel>
        <CustomTabPanel value={type} index={"landing_page_builder"}>
          <LandingPageBuilder
            languages={languages}
            studyId={studyId}
            canEdit={hasAccess}
          />
        </CustomTabPanel>
        <CustomTabPanel2 value={type} index={"documents"}>
          <Documents canEdit={hasAccess} />
        </CustomTabPanel2>
        {/* {features?.[featuresMap.wearable] && (
            <CustomTabPanel value={type} index={"device_config"}>
              <ConfigBody canEdit={canEdit} />
            </CustomTabPanel>
          )} */}
      </Box>
    </>
  );
};

export default StudySettings;
